import { render } from "./EditorAlignSelection.vue?vue&type=template&id=62c20d50"
import script from "./EditorAlignSelection.vue?vue&type=script&lang=js"
export * from "./EditorAlignSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__